'use client';
'use strict';

var dayjs = require('dayjs');
var isYearDisabled = require('../is-year-disabled/is-year-disabled.cjs');

function getYearInTabOrder(years, minDate, maxDate, getYearControlProps) {
  const enabledYears = years.flat().filter(
    (year) => !isYearDisabled.isYearDisabled(year, minDate, maxDate) && !getYearControlProps?.(year)?.disabled
  );
  const selectedYear = enabledYears.find((year) => getYearControlProps?.(year)?.selected);
  if (selectedYear) {
    return selectedYear;
  }
  const currentYear = enabledYears.find((year) => dayjs().isSame(year, "year"));
  if (currentYear) {
    return currentYear;
  }
  return enabledYears[0];
}

exports.getYearInTabOrder = getYearInTabOrder;
//# sourceMappingURL=get-year-in-tab-order.cjs.map
